import React, {Component} from 'react';
import Select from 'react-select';

const ALL = 'ALL';
const TODOS = 'Todos';
export default class MultiSelectField extends Component {
    constructor(props){
        super(props);
        this.state = {
            removeSelected: true,
            stayOpen: false,
            value: [],
            options: this.props.data,
            placeHolder: this.props.placeHolder ? this.props.placeHolder : "",
            dataDefault:[{value: ALL , label: TODOS}],
        };
    }

    getValue = (array) =>{
        let values =[];
        array.map((item)=> values.push(item.value));
        return values;
    }

    handleSelectChange = (values) => {
            this.setState({ values });
            this.props.handleSelectChange( values);
    }

    isAll = (item) => {
        if(item.length > 0)
            return this.props.enableAll && (item.value == ALL);

        return false;
    }

    addLabelAll = (values) =>{
        if(this.props.enableAll){
            return this.state.dataDefault.concat(values);
        }
        return values;
    }

    render () {
        const { stayOpen, placeHolder,removeSelected,dataDefault } = this.state;
        const {valuesSelected, data, multi, style } = this.props;

        return (
            <div className="section" style={style}>
                <Select
                    closeOnSelect={!stayOpen}
                    multi = {multi == undefined || multi == false  ? false : true}
                    onChange={this.handleSelectChange}
                    options={this.isAll(valuesSelected) ? dataDefault : this.addLabelAll(data)}
                    placeholder={placeHolder}
                    removeSelected={removeSelected}
                    value={valuesSelected.length == 0 ? '' : valuesSelected}
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/multiSelect/multiSelect.js